
<div
    class="Skeleton"
    :class="[
        {
            'with-background': withBackground,
        },
    ]"
>
    <div v-if="showCards" class="skeleton-cards-grid">
        <div v-for="i in cardCount" :key="`card-${i}`" class="skeleton-card"></div>
    </div>

    <div v-if="showToolbar" class="skeleton-toolbar"></div>

    <div v-if="showTable" class="skeleton-table"></div>
</div>
